export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: () => import('./Dashboard.vue')
  }
]
